var React = require('react');

function MinusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.166 0.0819995H5.732V1.578H0.166V0.0819995Z","fill":"white"}));
}

MinusIcon.defaultProps = {"width":"6","height":"2","viewBox":"0 0 6 2","fill":"none"};

module.exports = MinusIcon;

MinusIcon.default = MinusIcon;
